/**
 * Оптимизации для мобильных устройств (Android, iOS)
 */

/**
 * Определяет, является ли устройство мобильным
 */
export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Определяет, является ли устройство Android
 */
export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

/**
 * Проверяет поддержку Web Animations API
 */
export function supportsWebAnimations() {
  return typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
}

/**
 * Проверяет поддержку requestAnimationFrame
 */
export function supportsRequestAnimationFrame() {
  return typeof requestAnimationFrame !== 'undefined';
}

/**
 * Создает оптимизированную анимацию для мобильных устройств
 */
export function createMobileOptimizedAnimation(element, keyframes, options = {}) {
  const {
    duration = 500,
    easing = 'ease-out',
    fallbackToCSS = true
  } = options;
  
  // Используем Web Animations API если доступен
  if (supportsWebAnimations() && element.animate) {
    try {
      return element.animate(keyframes, { duration, easing });
    } catch (error) {
      console.warn('[mobile] Web Animations API failed, using CSS fallback:', error);
    }
  }
  
  // Fallback на CSS анимацию
  if (fallbackToCSS) {
    const animationId = `mobile-anim-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const className = `mobile-animation-${animationId}`;
    
    // Создаем уникальный CSS класс для этой анимации
    if (!document.getElementById(`mobile-animation-style-${animationId}`)) {
      const style = document.createElement('style');
      style.id = `mobile-animation-style-${animationId}`;
      
      // Преобразуем keyframes в CSS
      let cssKeyframes = '@keyframes ' + className + ' {\n';
      keyframes.forEach((frame, index) => {
        const percent = frame.offset ? (frame.offset * 100) : (index / (keyframes.length - 1) * 100);
        cssKeyframes += `  ${percent}% {\n`;
        if (frame.transform) cssKeyframes += `    transform: ${frame.transform};\n`;
        if (frame.opacity !== undefined) cssKeyframes += `    opacity: ${frame.opacity};\n`;
        if (frame.color) cssKeyframes += `    color: ${frame.color};\n`;
        cssKeyframes += `  }\n`;
      });
      cssKeyframes += '}\n';
      cssKeyframes += `.${className} { animation: ${className} ${duration}ms ${easing} forwards; }\n`;
      
      style.textContent = cssKeyframes;
      document.head.appendChild(style);
    }
    
    element.classList.add(className);
    
    const cleanup = () => {
      element.classList.remove(className);
      setTimeout(() => {
        const styleEl = document.getElementById(`mobile-animation-style-${animationId}`);
        if (styleEl) {
          styleEl.remove();
        }
      }, duration + 100);
    };
    
    setTimeout(cleanup, duration);
    
    return {
      onfinish: (callback) => {
        setTimeout(callback, duration);
      },
      cancel: cleanup
    };
  }
  
  return null;
}

/**
 * Оптимизирует производительность для мобильных устройств
 */
export function optimizeForMobile() {
  if (!isMobileDevice()) return;
  
  // Уменьшаем сложность анимаций на мобильных
  const style = document.createElement('style');
  style.id = 'mobile-optimizations';
  style.textContent = `
    /* Оптимизация для мобильных */
    .battle-combatant-panel {
      will-change: transform, opacity;
      transform: translateZ(0); /* Аппаратное ускорение */
    }
    
    .battle-damage,
    .battle-damage-enhanced {
      will-change: transform, opacity;
      transform: translateZ(0);
    }
    
    /* Упрощенные анимации для слабых устройств */
    @media (max-width: 768px) {
      .battle-animate-focus,
      .battle-animate-hit {
        animation-duration: 0.3s !important;
      }
    }
  `;
  document.head.appendChild(style);
  
  // Отключаем сложные эффекты на слабых устройствах
  if (isAndroid()) {
    // Некоторые старые Android устройства могут не поддерживать сложные анимации
    const userAgent = navigator.userAgent;
    const androidVersion = userAgent.match(/Android (\d+\.\d+)/);
    if (androidVersion && parseFloat(androidVersion[1]) < 7.0) {
      console.log('[mobile] Old Android detected, using simplified animations');
      // Можно добавить флаг для упрощенных анимаций
    }
  }
}

/**
 * Инициализирует оптимизации при загрузке
 */
export function initMobileOptimizations() {
  if (typeof document !== 'undefined' && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeForMobile);
  } else {
    optimizeForMobile();
  }
}





